<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">INVENTORY</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 inventory-page">
      <!-- <span class="mask bg-white"></span> -->
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <h2>Stock Transfer</h2>
            <div class="row" v-if="isLoadDone">
              <div class="col-lg-4">
                <div class="stock-request-left">
                  <div class="d-flex justify-content-between">
                    <!-- <div>Updated on: YYYY-MM-DD</div> -->
                    <div></div>
                    <div>
                      Status:
                      <span style="font-weight: bold" :style="{ color: form.status_color && !isCopy ? form.status_color : '#007bff' }"
                        >{{ form.status_label && !isCopy ? form.status_label : 'New' }}</span
                      >
                    </div>
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for> Document No. </label>
                    </div>
                    <div class="col-8">{{ form.document_no }}</div>
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for>
                        Source Type <span class="text-danger">*</span></label
                      >
                    </div>
                    <div class="col-8">
                      <Multiselect
                        v-model="form.source_type"
                        :options="sourceTypes"
                        :canClear="false"
                        placeholder="Source Type"
                        @change="changeSourceType"
                      />
                    </div>
                  </div>
                  <div
                    class="row mt-1"
                    v-if="fieldRequired.isSourceTypeRequire"
                  >
                    <div class="col-4"></div>
                    <div class="col-8 is-invalid">The field is required.</div>
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for>
                        Source Name <span class="text-danger">*</span></label
                      >
                    </div>
                    <div class="col-8">
                      <Multiselect
                        v-model="form.source_name"
                        :options="sourceNames"
                        :canClear="false"
                        placeholder="Source Name"
                        :disabled="!form.source_type || form.source_type == 1"
                        @change="changeSourceName"
                      />
                    </div>
                  </div>
                  <div
                    class="row mt-1"
                    v-if="fieldRequired.isSourceNameRequire"
                  >
                    <div class="col-4"></div>
                    <div class="col-8 is-invalid">The field is required.</div>
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for>
                        To Branch <span class="text-danger">*</span></label
                      >
                    </div>
                    <div class="col-8">
                      <Multiselect
                        v-model="form.branch"
                        :options="physicalBranches"
                        :canClear="false"
                        placeholder="Branch"
                        :disabled="!form.source_type && !form.source_name"
                        @change="changeBranch"
                      />
                    </div>
                  </div>
                  <div class="row mt-1" v-if="fieldRequired.isBranchRequire">
                    <div class="col-4"></div>
                    <div class="col-8 is-invalid">The field is required.</div>
                  </div>
                  <div class="row mt-1" v-if="fieldRequired.isBranchAndSourceNameSame">
                    <div class="col-4"></div>
                    <div class="col-8 is-invalid">The branch and source name cannot be the same.</div>
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for> Transfer Date </label>
                    </div>
                    <div class="col-8 d-flex">
                      <Datepicker
                        v-model="form.transfer_date"
                        :enable-time-picker="true"
                        class="w-100"
                        :format="formatDateShowWithTime"
                        :minute-increment="5"
                        :auto-apply="true"
                        placeholder="Transfer Date"
                        :disabled="true"
                      />
                    </div>
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for> Remarks </label>
                    </div>
                    <div class="col-8 d-flex">
                      <material-input
                        v-model="form.remarks"
                        type="text"
                        id="remarks"
                        name="remarks"
                        placeholder="Remarks"
                      />
                    </div>
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for>
                        Transfer Directly
                      </label>
                    </div>
                    <div class="col-8 d-flex">
                      <MaterialRadio
                        v-model="form.transfer_directly"
                        id="transfer_directly"
                        name="transfer_directly"
                        class="ps-0"
                        value="1"
                      >
                        Yes
                      </MaterialRadio>
                      <MaterialRadio
                        v-model="form.transfer_directly"
                        id="transfer_directly"
                        name="transfer_directly"
                        value="0"
                      >
                        No
                      </MaterialRadio>
                    </div>
                  </div>
                  <div class="mt-3" style="color: #007bff">
                    If Yes, the stock will be added to Destination directly and transfer status will be Completed.
                  </div>
                  <div class="row mt-3 align-items-center">
                    <div class="col-4">
                      <label class="fw-bold mb-0" for> Unit Cost </label>
                    </div>
                    <div class="col-8 d-flex">
                      <MaterialRadio
                        v-model="form.unit_cost"
                        id="unit_cost"
                        name="unit_cost"
                        class="ps-0"
                        value="1"
                        :disabled="true"
                      >
                        Manual
                      </MaterialRadio>
                      <MaterialRadio
                        v-model="form.unit_cost"
                        id="unit_cost"
                        name="unit_cost"
                        value="2"
                        @change="selectCurrentCost($event)"
                      >
                        Current Cost
                      </MaterialRadio>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="stock-request-right">
                  <div class="row align-items-center">
                    <h3 class="col-md-6 title-page mb-0">Item List</h3>
                    <div class="col-md-6 d-flex justify-content-end">
                      <div class="d-flex align-items-center">
                        <div class="sample-file me-3" @click="downloadSampleFile()">sample.xlsx</div>
                        <material-input
                          hidden
                          type="file"
                          id="file_import"
                          name="file_import"
                          @change="onFileChangeItems($event)"
                          accept=".xlsx"
                        />
                        <material-button
                          @click="chooseFile()"
                          class="btn btn-sm btn-background mw-185px me-3"
                        >
                          Import
                        </material-button>
                      </div>
                      <material-button
                        class="btn btn-sm btn-background"
                        @click="openModalSelectItem()"
                      >
                        <i class="material-icons css-icon">addoutlined</i>
                        Add Item
                      </material-button>
                    </div>
                  </div>
                  <div class="mt-3">
                    <div class="table-responsive p-0 mt-3">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-left font-weight-bolder w-20">
                              Item No.
                            </th>
                            <th class="text-left font-weight-bolder w-15">
                              Barcode
                            </th>
                            <th class="text-left font-weight-bolder w-45">
                              Item Name
                            </th>
                            <th class="text-left font-weight-bolder w-10">
                              Unit Cost
                            </th>
                            <th class="text-left font-weight-bolder w-10">
                              Qty
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="itemsSelected.length">
                          <tr
                            v-for="(value, index) in itemsSelected"
                            :key="index"
                          >
                            <td class="text-left text-xss">
                              {{ value.item_no }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.barcode }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.item_name }}
                            </td>
                            <td class="text-left text-xss">
                              <MaterialInput
                                v-model="value.unit_cost"
                                type="number"
                                id="unit_cost"
                                name="unit_cost"
                                placeholder="Unit Cost"
                                :disabled="form.unit_cost == currentCost"
                              />
                            </td>
                            <td class="text-left text-xss">
                              <MaterialInput
                                v-model="value.qty"
                                type="number"
                                id="qty"
                                name="qty"
                                placeholder="Qty"
                                @change="calculateQty"
                                min="0"
                                step="1"
                                @input="value.qty = Math.floor(value.qty)"
                                :disabled="true"
                              />
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    class="mt-5 text-end font-weight-bold"
                    style="font-size: 24px; color: #222"
                  >
                    <div>Type: {{ idsSelected.length }}</div>
                    <div>Qty: {{ totalQty }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-5">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="cancelStockTransfer()"
              >
                Cancel
              </material-button>
              <material-button
                v-if="!form.status || form.status == STATUS_IN_TRANSIT || isCopy"
                class="mx-2 btn btn-sm btn-background btn-save"
                @click="createStockTransfer()"
              >
                Save
              </material-button>
            </div>
          </div>
        </div>
      </div>
      <form
        :action="`${actionDownload}/merchant/inventory/download-sample-file/transfer`"
        method="POST"
      >
        <input type="hidden" name="merchantId" :value="merchantIdExport" />
        <input type="hidden" name="merchant_code" :value="merchantCode" />
        <input type="hidden" name="token" :value="token" />
        <input id="downloadForm" type="submit" class="d-none" />
      </form>
      <material-loading :active="loaderActive" />
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
    </div>
    <ModalSelectItem
      :itemsSelected="itemsSelected"
      :idsSelected="idsSelected"
      :form="form"
      :physicalBranches="physicalBranches"
      :keyReload="keyReloadSelectItem"
      @add-item="addItem"
    ></ModalSelectItem>
    <ModalError :message="importErrMessage" />
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
// import moment from "moment";
import MaterialInput from "@/components/MaterialInput.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@vueform/multiselect/themes/default.css";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import MaterialRadio from "@/components/MaterialRadio.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import $ from "jquery";
import ModalSelectItem from "./components/ModalSelectItem.vue";
import InventoryService from "../../services/inventory.service";
import { SOURCE_TYPE_SUPPLIER, SOURCE_TYPE_WAREHOUSE, UNIT_COST_CURRENT, STATUS_IN_TRANSIT, STOCK_TRANSFER } from "./mock_data";
import CommonFunctionService from "../../services/commonFunction.service";
import ModalError from "./components/ModalError.vue";
import TokenService from "../../services/token.service";
import { scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "inventory-stock-request",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialInput,
    Multiselect,
    Datepicker,
    MaterialRadio,
    MaterialButton,
    ModalSelectItem,
    ModalError
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      isLoadDone: false,
      loaderActive: false,
      snackbar: null,
      message: "",
      form: {
        document_no: "",
        source_type: 0,
        source_name: 0,
        branch: 0,
        transfer_date: new Date(),
        remarks: "",
        transfer_directly: 0,
        unit_cost: 2, // 1: Manual, 2: Current Cost
      },
      newDocumentNo: "",
      sourceTypes: [],
      sourceNames: [],
      physicalBranches: [],
      keyReloadSelectItem: "keyReloadSelectItem",
      itemsSelected: [],
      idsSelected: [],
      totalQty: 0,
      currentCost: UNIT_COST_CURRENT,
      fieldRequired: {},
      id: this.$route.params.id ?? 0,
      STATUS_IN_TRANSIT: STATUS_IN_TRANSIT,
      isCopy: this.$route.query.copy ?? false,
      fileImport: null,
      importErrMessage: "",
    };
  },
  async created() {
    this.isCopy = this.$route.query.copy == "true" ? true : false;
    this.isLoadDone = false;
    await this.getDataFilter();

    if (this.id) {
      await this.getDetailStockTransfer();
    }

    this.isLoadDone = true;
  },
  methods: {
    formatPrice(price) {
      price = parseFloat(price).toFixed(2);
      return "$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 });
    },

    chooseFile() {
      if ((this.form.source_name == 0 || this.form.source_name == null) || (this.form.branch == 0 || this.form.branch == null)) {
        alert("Please select source name and branch");
        return;
      }

      $("#file_import").click();
    },

    onFileChangeItems(e) {
      this.fileImport = null;
      let files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      let file = files[0];

      if (file != null || file != undefined) {
        if (
          ![
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
          ].includes(file.type)
        ) {
          alert("File must be an xlsx or xls.");
        } else {
          this.fileImport = file;

          setTimeout(() => {
            this.importTransferItems();
          }, 100);
        }
      }

      $("#file_import")[0].value = "";
    },

    downloadSampleFile() {
      $("#downloadForm").click();
    },

    changeSourceName() {
      this.itemsSelected = [];
      this.idsSelected = [];
      this.calculateQty();
    },

    importTransferItems() {
      this.showLoader();
      this.importErrMessage = "";
      if (!this.fileImport) {
        alert("Please select file to import.");
        return;
      }

      var dataForm = {
        stock_action: STOCK_TRANSFER,
        source_name: this.form.source_name,
        branch: this.form.branch,
        file_import: this.fileImport,
      };

      InventoryService.importTransferItems(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.importErrMessage = data.error_message;

            if (this.importErrMessage == "") {
              this.snackbar = "success";
              this.message = "Imported successful";
              this.setTimeOutNotification();

              data.items.forEach((item) => {
                const existingIndex = this.itemsSelected.findIndex(
                  (existingItem) => existingItem.id === item.id
                );

                if (existingIndex !== -1) {
                  this.itemsSelected.splice(existingIndex, 1, item);
                } else {
                  this.itemsSelected.push(item);
                }
              });

              data.item_ids.forEach((id) => {
                if (!this.idsSelected.includes(id)) {
                  this.idsSelected.push(id);
                }
              });
              this.calculateQty();
            } else {
              $(".btn-error-modal").click();
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    async getDataFilter() {
      this.showLoader();
      var dataForm = {
        get_document_no: 1,
        get_source_type: 1,
        get_physical_branches: 1,
      };

      await InventoryService.getDataFilter(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.sourceTypes = data.source_types;
            this.physicalBranches = data.physical_branches;
            this.form.document_no = data.document_no;
            this.newDocumentNo = data.document_no;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    async getDetailStockTransfer() {
      this.showLoader();
      var dataForm = {
        id: this.id,
        in_out: 0,
        is_copy: this.isCopy,
      };

      await InventoryService.getDetailStockTransfer(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.clearForm();
            const data = response.data.data;
            this.form = data.stock_transfer;
            const sourceName = this.form.source_name;
            const branch = this.form.physical_branch_id;
            this.itemsSelected = data.items_selected;
            this.idsSelected = data.ids_selected;

            this.calculateQty();
            this.changeSourceType(this.form.source_type);

            this.form.source_name = sourceName;
            this.form.branch = branch;

            if (this.isCopy) {
              this.form.document_no = this.newDocumentNo;
              this.form.transfer_date = new Date();
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    createStockTransfer() {
      if (this.itemsSelected.length == 0) {
        alert("Please add item");
        return;
      }

      if (this.isCopy) {
        this.form.id = 0;
      }

      if (!this.processValidate()) {
        return;
      }

      this.showLoader();
      this.form.items = this.itemsSelected;
      this.form.transfer_date = typeof this.form.transfer_date == "string" ? this.form.transfer_date : this.formatDateShowWithTime(this.form.transfer_date);

      InventoryService.createStockTransfer(this.form).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            if (this.form.id) {
              this.message = "Stock transfer updated successfully";
            } else {
              this.message = "Stock transfer created successfully";
            }
            this.setTimeOutNotification();

            setTimeout(() => {
              this.$router.push({ name: "StockTransfers" });
            }, 1000);
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    cancelStockTransfer() {
      this.$router.push({ name: "StockTransfers" });
    },

    changeSourceType(value) {
      this.form.source_type = value;
      this.form.source_name = 0;
      this.form.branch = 0;
      console.log(this.form.source_type);

      if (value == SOURCE_TYPE_SUPPLIER) {
        this.sourceNames = [];
      } else {
        if (value == SOURCE_TYPE_WAREHOUSE) {
          this.form.source_name = -1;
        }

        this.sourceNames = this.physicalBranches;
      }
    },

    selectCurrentCost() {
      this.itemsSelected.forEach((item) => {
        item.unit_cost = item.unit_cost_default;
      });
    },

    openModalSelectItem() {
      if ((this.form.source_name == 0 || this.form.source_name == null) || (this.form.branch == 0 || this.form.branch == null)) {
        alert("Please select source name and branch");
        return;
      }

      this.keyReloadSelectItem = Math.random().toString();
      $(".btn-select-item-modal").click();
    },

    addItem(ids, items) {
      this.idsSelected = ids;
      this.itemsSelected = items;
      this.calculateQty();
    },

    updateTotalQty() {
      this.itemsSelected.forEach((item) => {
        this.totalQty += parseInt(item.qty ? item.qty : 0);
      });
    },

    calculateQty() {
      this.totalQty = this.itemsSelected.reduce(
        (total, item) => total + parseInt(item.qty ? item.qty : 0),
        0
      );
    },

    resetRequired() {
      this.fieldRequired.isSourceTypeRequire = false;
      this.fieldRequired.isSourceNameRequire = false;
      this.fieldRequired.isBranchRequire = false;
      this.fieldRequired.isBranchAndSourceNameSame = false;
    },

    processValidate() {
      this.resetRequired();
      var isValid = true;
      if (this.form.source_type == null || this.form.source_type == 0) {
        this.fieldRequired.isSourceTypeRequire = true;
        isValid = false;
      }

      if (this.form.source_name == null || this.form.source_name == 0) {
        this.fieldRequired.isSourceNameRequire = true;
        isValid = false;
      }

      if (this.form.branch == null || this.form.branch == 0) {
        this.fieldRequired.isBranchRequire = true;
        isValid = false;
      }

      if (this.fieldRequired.isSourceNameRequire == false && this.fieldRequired.isBranchRequire == false && this.form.source_name == this.form.branch) {
        this.fieldRequired.isBranchAndSourceNameSame = true;
        isValid = false;
      }

      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },

    formatDateShowWithTime(date) {
      return CommonFunctionService.formatDateShowWithTime(date)
    },

    clearForm() {
      (this.form = {
        document_no: "",
        source_type: 0,
        source_name: 0,
        branch: 0,
        transfer_date: new Date(),
        remarks: "",
        transfer_directly: 0,
        unit_cost: 2, // 1: Manual, 2: Current Cost
      }),
        (this.itemsSelected = []);
      this.idsSelected = [];
      this.totalQty = 0;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
        this.message = "";
      }, 3000);
    },
  },
};
</script>

<style scoped>
.page-header {
  min-height: calc(100vh - 70px) !important;
  margin-bottom: 16px;
}

.table-responsive {
  max-height: 50vh;
  overflow-y: auto;
}

.stock-request-left,
.stock-request-right {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  height: 100%;
}

:deep(.input-group.input-group-dynamic .form-control) {
  background-image: none;
  border: 1px solid #d9d9d9 !important;
  padding: 8px !important;
  margin-bottom: 0;
}

.css-icon {
  position: absolute;
  left: 17px !important;
  font-size: 18px !important;
  top: 7px !important;
}

.table-responsive thead tr th {
  padding: 0.5rem !important;
}

.sample-file {
  cursor: pointer;
  text-decoration: underline;
  color: #133067;
}

@media (max-width: 992px) {
  .stock-request-right {
    margin-top: 16px;
  }
}
</style>
